import React from "react";
import { Box, Button, Paper, Stack, Typography } from "@mui/material";
import {
    AccessTime as TimeIcon,
    Apartment as ProjectIcon,
    LocationOn as LocationIcon,
} from "@mui/icons-material";
import { format } from "date-fns";

const safeTime = (value) => {
    if (!value) return null;
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return null;
    return format(date, "HH:mm");
};

const ManifestRouteSummary = ({ manifest, origen, destino, canEdit, onEditRoute }) => {
    return (
        <Paper variant="outlined" sx={{ p: 2, borderRadius: 2.5, bgcolor: "#fafafa" }}>
            <Stack spacing={1.2}>
                <Box display="flex" alignItems="center" gap={1}>
                    <ProjectIcon fontSize="small" />
                    <Typography variant="body2">
                        <strong>Proyecto:</strong> {manifest?.pronom || "N/D"}
                    </Typography>
                </Box>

                <Box display="flex" alignItems="center" gap={1}>
                    <LocationIcon color="primary" />
                    <Typography variant="body2">
                        <strong>Ruta:</strong>{" "}
                        <b>{origen?.locnom || manifest?.manori || "Origen N/D"}</b>
                        {safeTime(origen?.parhorest) && (
                            <Box component="span" sx={{ ml: 1 }}>
                                <TimeIcon fontSize="inherit" /> {safeTime(origen.parhorest)}
                            </Box>
                        )}
                        {" → "}
                        <b>{destino?.locnom || manifest?.mandes || "Destino N/D"}</b>
                        {safeTime(destino?.parhorest) && (
                            <Box component="span" sx={{ ml: 1 }}>
                                <TimeIcon fontSize="inherit" /> {safeTime(destino.parhorest)}
                            </Box>
                        )}
                    </Typography>
                </Box>

                {canEdit && (
                    <Box>
                        <Button variant="outlined" size="small" onClick={onEditRoute}>
                            {origen && destino ? "Editar ruta" : "Asignar ruta"}
                        </Button>
                    </Box>
                )}
            </Stack>
        </Paper>
    );
};

export default ManifestRouteSummary;